<template>
    <div v-if="!activeGateways().has_gateway">
        <div>
            <p
                class="font-weight-bolder text-center"
                :style="{ fontSize: '15px' }"
            >
                {{ $t('message.no_gateway') }}
            </p>
            <div class="d-flex justify-content-center">
                <div>
                    <router-link class="btn btn-success mt-3" to="/gateways">
                        {{ $t('btn.create_gateway') }}
                    </router-link>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="!activeGateways().has_active_gateway">
        <div>
            <p
                class="font-weight-bolder text-center"
                :style="{ fontSize: '15px' }"
            >
                {{ $t('message.no_active_gateway') }}
            </p>
        </div>
    </div>
    <form v-else id="ps_form" class="px-3 mx-2">
        <div class="d-none">
            <div class="form-group">
                <label for="full_name">
                    {{ $t('label.first_and_last_name') }}
                </label>
                <input
                    id="full_name"
                    name="full_name"
                    disabled
                    v-model="form_data.full_name"
                />
            </div>
            <div class="form-group">
                <label for="user_name">
                    {{ $t('label.user_name') }}
                </label>
                <input
                    disabled
                    id="user_name"
                    name="user_name"
                    v-model="form_data.user_name"
                />
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 col-sm-12">
                <!--        <div>-->
                <!--          <div class="input-group py-2">-->
                <!--            <label class="input-group">-->
                <!--              {{ $t("label.pardakhtShakhsiLink") }}-->
                <!--            </label>-->
                <!--            <input-->
                <!--                class="form-control"-->
                <!--                type="text"-->
                <!--                dir="ltr"-->
                <!--                name="register_link"-->
                <!--                id="register_link"-->
                <!--                :value="ps_link"-->
                <!--                disabled-->
                <!--            />-->
                <!--          </div>-->
                <!--        </div>-->
                <div>
                    <div class="form-group py-2">
                        <label for="shop_id">
                            {{ $t('label.choose_gateway') }}
                        </label>
                        <select
                            id="shop_id"
                            name="shop_id"
                            v-model="form_data.shop_id"
                            @change="updateShopType"
                            class="form-control kt-selectpicker"
                        >
                            <option
                                v-for="gateway in activeGateways().gates"
                                :key="gateway.id"
                                :value="gateway.id"
                            >
                                {{ gateway.title }} -
                                {{ getGatewayType(gateway.type) }}
                            </option>
                        </select>
                    </div>
                </div>
                <!--        <div v-if="vip_gateways.length > 0">-->
                <!--          <div class="form-group  py-2">-->
                <!--            <label for="ivr_shop_id">-->
                <!--              {{ $t("label.vip_gateway") }}-->
                <!--            </label>-->
                <!--            <select-->
                <!--                id="ivr_shop_id"-->
                <!--                name="ivr_shop_id"-->
                <!--                v-model="form_data.ivr_shop_id"-->
                <!--                class="form-control kt-selectpicker"-->
                <!--            >-->
                <!--              <option-->
                <!--                  v-bind:key="ivr.id"-->
                <!--                  v-for="ivr in vip_gateways"-->
                <!--                  :value="ivr.id"-->
                <!--              >-->
                <!--                {{ ivr.title }}-->
                <!--              </option>-->
                <!--            </select>-->
                <!--          </div>-->
                <!--        </div>-->
                <!--        <div>-->
                <!--          <div class="form-group  py-2">-->
                <!--            <label for="description">-->
                <!--              {{ $t("label.pardakht_shakhsi_description") }}-->
                <!--            </label>-->
                <!--            <Textarea-->
                <!--                class="form-control no-resize"-->
                <!--                rows="6"-->
                <!--                id="description"-->
                <!--                name="description"-->
                <!--                v-model="form_data.description"-->
                <!--            >-->
                <!--          </Textarea>-->
                <!--          </div>-->
                <!--        </div>-->
            </div>
            <div class="col-lg-6 col-sm-12">
                <div>
                    <div class="form-group py-2">
                        <label for="wage_type">
                            {{ $t('label.wage_settings') }}
                        </label>
                        <select
                            id="wage_type"
                            name="wage_type"
                            v-model="form_data.wage_type"
                            class="form-control kt-selectpicker"
                        >
                            <option
                                v-bind:key="wage.id"
                                v-for="wage in wages"
                                :value="wage.id"
                            >
                                {{ wage.value }}
                            </option>
                        </select>
                    </div>
                </div>

                <!--        <div class="mb-3">-->
                <!--          <label for="pay_link_title">-->
                <!--              {{ $t('label.pay_link_title') }}-->
                <!--          </label>-->
                <!--          <select-->
                <!--              id="pay_link_title"-->
                <!--              name="pay_link_title"-->
                <!--              v-model="form_data.pay_link_title"-->
                <!--              class="form-control kt-selectpicker"-->
                <!--          >-->
                <!--              <option :value="form_data.full_name">{{ form_data.full_name }}</option>-->
                <!--              <option-->
                <!--                  v-bind:key="gateway.id"-->
                <!--                  v-for="gateway in active_gateways"-->
                <!--                  :value="gateway.title"-->
                <!--              >-->
                <!--                  {{ gateway.title }}-->
                <!--              </option>-->
                <!--          </select>-->
                <!--        </div>-->

                <!--        <div>-->

                <!--          <div class="form-group form-check py-2">-->
                <!--            <label class="switch">-->
                <!--              <input-->
                <!--                type="checkbox"-->
                <!--                id="show_phone_number"-->
                <!--                v-model="form_data.show_phone_number"-->
                <!--              />-->
                <!--              <span class="slider round"></span>-->
                <!--            </label>-->
                <!--            <label-->
                <!--              for="show_phone_number"-->
                <!--              class="btn m-0 p-0 text-secondary form-check-label pr-4"-->
                <!--              >{{ $t("label.show_phone_number") }}</label-->
                <!--            >-->
                <!--          </div>-->

                <!--          <div class="form-group form-check py-2">-->
                <!--            <label class="switch">-->
                <!--              <input-->
                <!--                type="checkbox"-->
                <!--                id="show_name_in_qr_print"-->
                <!--                v-model="form_data.show_name_in_qr_print"-->
                <!--              />-->
                <!--              <span class="slider round"></span>-->
                <!--            </label>-->
                <!--            <label-->
                <!--              for="show_name_in_qr_print"-->
                <!--              class="btn m-0 p-0 text-secondary form-check-label pr-4"-->
                <!--              >نمایش نام در پرینت QR code</label-->
                <!--            >-->
                <!--          </div>-->
                <!--            <div>-->
                <!--                <div class="input-group py-2">-->
                <!--                    <label class="input-group">-->
                <!--                        {{ $t("label.constant_amount") }}-->
                <!--                    </label>-->
                <!--                    <input-->
                <!--                        class="form-control"-->
                <!--                        type="text"-->
                <!--                        dir="ltr"-->
                <!--                        name="constant_amount"-->
                <!--                        id="constant_amount"-->
                <!--                        v-model="form_data.constant_amount"-->
                <!--                    />-->
                <!--                </div>-->
                <!--            </div>-->
                <!--            <div>-->
                <!--                <div class="form-group   py-2">-->
                <!--                    <label for="wage_type">-->
                <!--                        {{ $t("label.after_success_pay") }}-->
                <!--                    </label>-->
                <!--                    <select-->
                <!--                        id="after_success_pay_type"-->
                <!--                        name="after_success_pay_type"-->
                <!--                        v-model="form_data.after_success_pay_type"-->
                <!--                        class="form-control kt-selectpicker"-->
                <!--                    >-->
                <!--                        <option v-bind:key="after_pay_type.id" v-for="after_pay_type in after_pay_types" :value="after_pay_type.id">-->
                <!--                            {{ after_pay_type.value }}-->
                <!--                        </option>-->
                <!--                    </select>-->
                <!--                </div>-->
                <!--            </div>-->
                <!--            <div>-->
                <!--                <div class="input-group py-2">-->
                <!--                    <label class="input-group" v-if="form_data.after_success_pay_type == 2">-->
                <!--                        {{ $t("label.special_link") }}-->
                <!--                    </label>-->
                <!--                    <label class="input-group" v-else>-->
                <!--                        {{ $t("label.special_link_in_receipt") }}-->
                <!--                    </label>-->
                <!--                    <input-->
                <!--                        style="text-align: left"-->
                <!--                        class="form-control"-->
                <!--                        type="text"-->
                <!--                        dir="ltr"-->
                <!--                        name="callback_url"-->
                <!--                        id="callback_url"-->
                <!--                        placeholder="https://google.com"-->
                <!--                        v-model="form_data.callback_url"-->
                <!--                    />-->
                <!--                </div>-->
                <!--            </div>-->
                <!--            <div v-if="form_data.after_success_pay_type == 1">-->
                <!--                <div class="form-group  py-2">-->
                <!--                    <label for="after_success_pay_description">-->
                <!--                        {{ $t("label.after_success_pay_description") }}-->
                <!--                    </label>-->
                <!--                    <Textarea-->
                <!--                        class="form-control no-resize"-->
                <!--                        rows="6"-->
                <!--                        id="after_success_pay_description"-->
                <!--                        name="after_success_pay_description"-->
                <!--                        v-model="form_data.after_success_pay_description"-->
                <!--                    >-->
                <!--                   </Textarea>-->
                <!--                </div>-->
                <!--            </div>-->

                <!--          <div class="form-group py-2">-->
                <!--            <label>-->
                <!--              {{ $t("label.profile_image") }}-->
                <!--            </label>-->
                <!--            <label-->
                <!--                for="logo_file"-->
                <!--                class="d-block btn btn-outline-success btn-block btn-pill label-file"-->
                <!--            >-->
                <!--              <i class="fas fa-paperclip"></i>-->
                <!--              {{ $t("gateway.btn.click_me") }}-->
                <!--            </label>-->
                <!--            <input-->
                <!--                @change="processLogoFile"-->
                <!--                type="file"-->
                <!--                class="custom-file-upload"-->
                <!--                name="profile_image"-->
                <!--                id="logo_file"-->
                <!--                accept=".jpg,.jpeg,image/png"-->
                <!--            />-->
                <!--          </div>-->

                <!--        </div>-->
            </div>
        </div>
    </form>
</template>

<script>
import $ from 'jquery';
import { i18n } from '@/plugins/i18n';
import { mapGetters } from 'vuex';
import Textarea from '@/components/elements/form/textarea';
import { gatewayTypes } from '@/constants/gatewayTypes';
import { IvrShopTypes } from '@/constants/IvrShopTypes';
import { shopGatewayService } from '@/common/shop.service';

export default {
    components: { Textarea },
    props: {
        form_data: {
            shop_id: null,
            shop_type: null,
            default() {
                return {};
            },
            type: Object
        }
    },
    data() {
        return {
            merged_gateways: [],
            shop_gateways: [],
            vip_gateways: [],
            wages: [
                {
                    id: 0,
                    value: this.$t('gateway.wages.from_me')
                },
                {
                    id: 1,
                    value: this.$t('gateway.wages.from_payer')
                },
                {
                    id: 2,
                    value: this.$t('gateway.wages.half')
                }
            ],
            after_pay_types: [
                {
                    id: 1,
                    value: this.$t('label.show_receipt')
                },
                {
                    id: 2,
                    value: this.$t('label.redirect_to_special_link')
                }
            ]
        };
    },
    mounted() {
        this.mergeGateways();
        this.$store.dispatch('gateway/fetch').finally(() => {
            this.afterDispatch();
        });
    },
    methods: {
        updateShopType() {
            const selectedGateway = this.activeGateways().gates.find(
                (gateway) => gateway.id === this.form_data.shop_id
            );
            if (selectedGateway) {
                this.form_data.shop_type = [1, 3].includes(selectedGateway.type)
                    ? 3
                    : 2;
            }
        },
        processLogoFile(event) {
            this.form_data.profile_image = event.target.files[0];

            if (this.form_data.profile_image !== undefined) {
                let size_validation = this.validateSize(event.target);
                if (size_validation !== false) {
                    let format_validation = this.validateFormat(event.target);
                    if (format_validation) return; // validation pass
                }
            }

            delete this.form_data.profile_image; // if validation fails
        },
        getGatewayType(shop_type) {
            if (shop_type === 2) {
                return i18n.t('label.pardakht_yari_gateway');
            } else if (shop_type === 1) {
                return i18n.t('label.star_shop_gateway');
            } else {
                return i18n.t('label.unknown');
            }
        },

        mergeGateways() {
            shopGatewayService
                .fetch()
                .then((response) => {
                    this.shop_gateways = response.data.data.gateways;
                    console.log(this.shop_gateways);
                })
                .catch(({ response }) => {
                    console.error('Error fetching shop gateways:', response);
                })
                .finally(() => {});

            this.merged_gateways = [
                ...this.gateways,
                ...this.shop_gateways
            ].map((gateway) => {
                return {
                    ...gateway,
                    shop_type: [1, 3].includes(gateway.type) ? 3 : 2
                };
            });
        },
        validateSize(file) {
            var FileSize = file.files[0].size / 1024 / 1024; // in MB
            if (FileSize > 1) {
                alert(i18n.t('authenticate.hint.fourth'));
                $(file).val('');
                return false;
            } else {
                return true;
            }
        },
        validateFormat(file) {
            let jq_file = $(file);
            let file_name = jq_file.val();
            let extension = file_name.replace(/^.*\./, '');
            if (extension === file_name) {
                extension = '';
            } else {
                extension = extension.toLowerCase();
            }
            let result = true;

            switch (extension) {
                case 'jpg':
                case 'jpeg':
                case 'png':
                    break;
                default:
                    alert(i18n.t('authenticate.input_format_err'));
                    $(file).val('');
                    result = false;
            }
            return result;
        },
        afterDispatch() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            });
        },
        activeGateways() {
            var active_gateways = [];

            if (this.merged_gateways.length < 1) {
                active_gateways.has_gateway = false;
                return active_gateways;
            }

            active_gateways.has_gateway = true;
            active_gateways.gates = [];
            active_gateways.has_active_gateway = false;

            for (const gateway of this.merged_gateways) {
                if (
                    gateway.gateway_type === gatewayTypes.PARDAKHTYARI ||
                    gateway.gateway_type === gatewayTypes.IVR
                ) {
                    if (gateway.gateway_type !== gatewayTypes.IVR) {
                        active_gateways.gates.push(gateway);
                    }
                    active_gateways.has_active_gateway = true;
                }
            }

            return active_gateways;
        }
    },
    computed: {
        ...mapGetters('gateway', [
            'gateways',
            'legal_gateways',
            'active_gateways',
            'ivrs'
        ]),
        ...mapGetters('user', ['current_user']),
        ps_link() {
            return 'paystar.ir/@' + this.current_user.username;
        },
        pardakht_yari_gateways() {
            let res = [];

            for (let i in this.gateways) {
                if (
                    this.gateways[i].gateway_type == 0 &&
                    this.gateways[i].status == 1
                ) {
                    res.push(this.gateways[i]);
                }
            }

            return res;
        }
    },
    watch: {
        ivrs(value) {
            for (let i = 0; i < value.length; i++) {
                if (value[i].type === IvrShopTypes.VIP)
                    this.vip_gateways.push(value[i]);
            }
        }
    }
};
</script>

<style scoped>
.no-resize {
    resize: none;
}

.modal-width {
    max-width: 700px;
}
</style>
